const service_api = "https://api.panichefs.com/pani-demo";

export { service_api };
